var _defs, _rect, _text, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _polygon2, _polygon3, _polygon4, _polygon5, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon6, _g, _g2, _path33, _path34, _path35, _g3, _path36, _path37, _path38, _g4, _rect3, _polygon7, _rect4, _path39, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailmarketingtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-17,.cls-26,.cls-27{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-15,.cls-3{fill:#2f2143;}.cls-4{fill:#2e1f42;}.cls-5{fill:#0a162f;}.cls-6{fill:#2e3052;}.cls-7{fill:#9a499c;}.cls-8{fill:#f5876d;}.cls-9{fill:#d45c49;}.cls-10{fill:#f8a692;}.cls-11{fill:#fff;}.cls-12{fill:#fbaa19;}.cls-13{fill:#f6891f;}.cls-14{fill:#fdcc51;}.cls-16,.cls-17{stroke:#524270;stroke-width:0.79px;}.cls-16,.cls-17,.cls-26,.cls-27{stroke-miterlimit:10;}.cls-17{stroke-dasharray:3.16 1.58;}.cls-18{opacity:0.5;}.cls-19{opacity:0.8;}.cls-20{fill:#fdc435;}.cls-21{opacity:0.6;}.cls-21,.cls-24{isolation:isolate;}.cls-22{clip-path:url(#clip-path);}.cls-23{fill:#e5ac24;}.cls-24{opacity:0.7;}.cls-25{clip-path:url(#clip-path-2);}.cls-26,.cls-27{stroke:#2f2143;}.cls-26{stroke-width:1.41px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 646.43,
    y: 123.5,
    width: 32.19,
    height: 27.65,
    transform: "translate(-12.26 87.71) rotate(-7.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 698.02,
    y: 113.35,
    width: 10.98,
    height: 12.45,
    transform: "translate(-9.59 92.91) rotate(-7.5)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email marketing tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(222.6 151.24)"
  }, "EMAIL MARKETING")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.17,148.76c6.37,23.18,27.36,29.65,27.36,29.65a63.28,63.28,0,0,0,18.84-7.15c-1.55-3.72-2.23-7.49-3.09-12.39-7.73,2.15-14.41,3.3-14.41,3.3-16.32-7.57-26.21-43.77-26.21-43.77C101,127.6,108.17,148.76,108.17,148.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.14,276.94l.28-1.65,8.25-49.64-26.48.56-6.13,50.73C91.09,277.07,98.21,276.94,107.14,276.94Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "102.86 276.94 90.1 226.19 53.5 228.59 78.14 276.94 102.86 276.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.66,118.4c1.85,2.3,5.56,25.82,6.14,49.69,0,.55,0,1.1,0,1.65q.09,3.8.16,7.6t.14,7.49c.07,4.06.13,8.06.18,11.91,0,.44,0,.87,0,1.31,0,3.75.08,7.35.11,10.71,0,.44,0,.88,0,1.31,0,5.05.06,9.52.06,13.1h0c0,.5,0,1,0,1.44,0,2.51,0,4.5,0,5.84a127.39,127.39,0,0,1-17.82,3.48l-.47.05-.8.09-.19,0q-1.54.18-3.09.3a120.58,120.58,0,0,1-15.32.28l-1.35-.08-1.2-.07-.55,0-1-.07a123.89,123.89,0,0,1-22.51-4c0-3-.07-9-.09-16.74v-1.29c0-8.57,0-19.08.13-29.91l0-2.57,0-3c0-.17,0-.34,0-.51s0-.46,0-.7c0-.47,0-.94,0-1.41l0-2.05,0-1.56c0-1,0-2.06,0-3.08.37-21.5,1.09-41.25,2.47-46.27a4,4,0,0,1,.4-1,6.16,6.16,0,0,1,.54-.68,9.37,9.37,0,0,1,.89-.9C60,116.67,64,114.21,68,111.87l1.42-.81c.07,0,11-3.72,11.07-3.76l11.43.8S107.94,115,110.66,118.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.53,149.36a.6.6,0,0,0-1.07-.36,59,59,0,0,0-9,17.86c-.42,1.34-.78,2.64-1.09,3.87l0,1.56,0,2.05c0,.47,0,.94,0,1.41,0,.24,0,.47,0,.7s0,.34,0,.51a73.48,73.48,0,0,1,2.32-9.78,57.91,57.91,0,0,1,8.82-17.46.67.67,0,0,0,.12-.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.85,211.74h0c12.34-.06,22.88-5.68,29.55-10.38A67.68,67.68,0,0,0,108,191.07a.6.6,0,1,0-.91-.77,66.11,66.11,0,0,1-11.43,10.11c-6.52,4.6-16.82,10.09-28.84,10.14a.6.6,0,0,0,0,1.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.72,215.93c10.71,0,21.4-6.1,21.88-6.38a.6.6,0,0,0,.22-.82.59.59,0,0,0-.81-.21c-.13.07-12.7,7.25-23.85,6.1a.59.59,0,0,0-.65.53.61.61,0,0,0,.53.65A26.71,26.71,0,0,0,79.72,215.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.65,126.88c10.32-2.86,19-11.6,19.38-12a.59.59,0,1,0-.85-.83c-.1.1-10.29,10.38-21.34,12.24a.59.59,0,1,0,.19,1.17A25.46,25.46,0,0,0,76.65,126.88Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,78.69c0,10.43,6.43,17.63,16.86,17.63s17.72-7.74,17.72-18.17S96.41,59.8,86,59.8C73.45,59.8,68,68.25,68,78.69Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.25,81.45s-3.65-5.51-1.72-9.76c2-4.41,1-3.44,1.48-6.75s2.9-4.67,5.79-5.14.91-3.8,4.9-5,7.2,3,9.77,1.11,8.88-2.79,10.66,0,3.35,2.77,5.24,2.68c2.27-.11,5.32,3.48,3.26,6.79s-5.52,2-5,4.26S106,75.94,102.07,81C100.88,82.57,68.25,81.45,68.25,81.45Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.35,83.18s-2.9-3.87-5-.67.89,12.64,6.17,10.34Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.32,89.93a.44.44,0,0,1-.43-.33A7,7,0,0,0,66,85.49a.44.44,0,0,1,.31-.83,7.66,7.66,0,0,1,4.42,4.7.45.45,0,0,1-.31.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.27,88.46a.42.42,0,0,1-.24-.07.45.45,0,0,1-.14-.62,4.2,4.2,0,0,1,1.68-1.35.45.45,0,0,1,.36.82,3.23,3.23,0,0,0-1.29,1A.44.44,0,0,1,67.27,88.46Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100.24,83.18s2.9-3.87,5.06-.67-.89,12.64-6.17,10.34Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.28,89.93a.45.45,0,0,0,.43-.33,7,7,0,0,1,3.87-4.11.44.44,0,0,0,.26-.57.45.45,0,0,0-.58-.26,7.65,7.65,0,0,0-4.41,4.7.44.44,0,0,0,.31.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.33,88.46a.42.42,0,0,0,.24-.07.44.44,0,0,0,.13-.62A4,4,0,0,0,102,86.42a.45.45,0,0,0-.36.82,3.07,3.07,0,0,1,1.28,1A.46.46,0,0,0,103.33,88.46Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M92.44,100.86v9.93a6.88,6.88,0,0,1-4.66,2.69c-4.36.52-9.08-4.09-9.08-4.09v-7.87Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.44,100.86V105c-2.54,2.82-7.06,3.52-13.74,2.53v-6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M68.82,83c0,.55.08,1.1.13,1.65.14,1.4.33,2.84.59,4.27,0,0,0,.1,0,.15C70.83,96,73.66,102.8,79.77,105c13.84,4.94,18.79-6.92,20.76-13.84.22-.77.42-1.63.59-2.54l0-.11c.19-1,.35-2.12.49-3.24.11-.84.2-1.68.28-2.53.2-2.07.33-4.14.42-6a9.77,9.77,0,0,0-6.26-9.59c-5.68-2.18-14.3-3.91-22.46.72a9.81,9.81,0,0,0-5,8.34C68.6,78.13,68.63,80.48,68.82,83Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.82,83c0,.55.08,1.1.13,1.65.14,1.4.33,2.84.59,4.27,0,0,0,.1,0,.15C70.83,96,73.66,102.8,79.77,105c13.84,4.94,18.79-6.92,20.76-13.84.22-.77.42-1.63.59-2.54l0-.11c.19-1,.35-2.12.49-3.24.11-.84.2-1.68.28-2.53l-2.07.54c-.6,3.13-1.49,7.7-2.64,9.83-1.82-4.43-11.91-.78-11.91-.78s-9-3.19-12,0a82.89,82.89,0,0,1-2.73-9ZM85,94c7.26-1,9.07.86,9.41,3a12.4,12.4,0,0,1-6.19,3.72c-2.49.57-7.54.52-11.22-2.38C76.63,96.62,76.22,91.74,85,94Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.59,83.73c0,1-.51,1.82-1.15,1.82s-1.15-.82-1.15-1.82.51-1.81,1.15-1.81S80.59,82.73,80.59,83.73Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94,83.73c0,1-.51,1.82-1.15,1.82s-1.16-.82-1.16-1.82.52-1.81,1.16-1.81S94,82.73,94,83.73Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.1,77.5s-3.65-1.44-6.45-.23l.28,1.56s4.12-.34,6.19.5A2.74,2.74,0,0,0,96.1,77.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.88,77.5s3.64-1.44,6.45-.23L81,78.83s-4.11-.34-6.18.5A2.68,2.68,0,0,1,74.88,77.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.75,91.6a4.84,4.84,0,0,1-1.64-.14.45.45,0,0,1-.32-.55.46.46,0,0,1,.55-.31,2.71,2.71,0,0,0,1.8,0,.52.52,0,0,0,.17-.44,68,68,0,0,0-1.1-6.75.44.44,0,1,1,.87-.18A64.54,64.54,0,0,1,87.2,90.1a1.37,1.37,0,0,1-.51,1.16A1.94,1.94,0,0,1,85.75,91.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M79.65,94.28c.37,1.83,1.58,5.21,5.66,5.21S90.55,96.4,91,94.28Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.87,83.26h-2a14.71,14.71,0,0,0-1.13-6.12c-1.38-3.71,1.56-5.34-.82-7.2s-8.29-1.06-12.41-1.19-10.8-.08-12.41.3-.74,3.06-.14,5.14-2,4.38-2.42,6.54a9.2,9.2,0,0,0,0,2.53H68.83c-.2-2.62-.23-5.06-.19-7a9.82,9.82,0,0,1,5-8.35c8.16-4.63,16.79-2.9,22.46-.72a9.77,9.77,0,0,1,6.26,9.59C102.24,78.74,102.1,81,101.87,83.26Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 60.8,
    y: 121.36,
    width: 113.44,
    height: 78.36,
    transform: "translate(-81.09 148.9) rotate(-50.44)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "123.43 91.86 127.31 95.06 129.94 170.8 55.06 182.51 51.19 179.31 126.2 167.71 123.43 91.86"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.62 169.83 113.69 226.68 111.6 229.22 110.06 227.94 107.94 169.97 111.62 169.83"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "182.51 140.66 183.85 141.76 181.56 144.52 125.35 153.21 124.79 149.58 182.51 140.66"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "51.19 179.31 126.2 167.71 123.43 91.86 51.19 179.31"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M110.57,201.36h2.08a4.55,4.55,0,0,0,4.12-2.76,26.67,26.67,0,0,1,1.22-2.54c1-1.3,3.63-3.48,4.63-3.55s.81,1.79.1,2.6a17.28,17.28,0,0,0-2.41,3c-.59,1.15,4.88,3.48,7.1,4s6.11-.65,6.49,1.19-2.54,2.11-2.54,2.11.86,1.66-1.57,3a2.26,2.26,0,0,1-1.14,2.5,2.49,2.49,0,0,1-1.64,2.59c-1.82.55-7.51,2.19-18.66-4.57Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.3,154c4.21,15.92,8.34,23,8.34,23a58.73,58.73,0,0,0,14.43,14,191.1,191.1,0,0,0,17.58,10.35c-1.87,2.43-3.19,7.24-2.46,8.67C87.66,210,68,188.69,68,188.69c-15.77-27.43-16.8-49.77-16.54-57.91a15.53,15.53,0,0,1,2.51-8.07,8,8,0,0,1,3-2.94,16.43,16.43,0,0,1,9.1,10.45C68.41,138.15,72.3,154,72.3,154Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M172.62,155.42s-5-1.77-7.31-.81,4.08,4.41,4.08,4.41-7.74-4.12-9.07-2.46,6.06,5.88,6.06,5.88-5.67-2-6.82-.82,4.14,4.47,4.14,4.47-4.66-1.12-5.63-.33,3.16,4.1,5.77,5,3-2.8,3-2.8,2.46-2.17,2.14-3.67c0,0,2.55-1.73,2.73-3.49C171.75,160.77,175.35,157.6,172.62,155.42Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M208.24,249.37a19.56,19.56,0,0,1,33.14-20.77"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M216.84,211.91a7.62,7.62,0,1,1-10.51-2.41,7.64,7.64,0,0,1,10.51,2.41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M591.52,215.26l-1.47.58"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M588.58,216.41c-28.82,11.08-59.61,19.13-69.69,6.87-10.63-12.92,11.55-36.84,2.2-50.28C501.6,145,385,219.27,341.67,180.24c-19.78-17.82-4.56-41.44-29.8-65.41-22-20.9-65.4-33.19-96-11.48-23.37,16.58-27.71,44.8-28.58,54.18"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M187.22,158.32c-.05.65-.09,1.18-.11,1.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "577.49 208.65 589.29 214.67 590.49 224.32 597.62 217.96 607.69 222.18 635.4 194.14 577.49 208.65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "589.29 214.67 634.52 194.36 610.59 207.89 594.84 216.79 590.49 224.32 590.49 224.32 589.29 214.67"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "594.84 216.79 597.62 217.96 590.49 224.32 594.84 216.79"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M667.21,173.49l2.78-1.27a3.53,3.53,0,0,0,1.91-4.12l-6.23-22.79-7.59,3.48L662.31,171a3.47,3.47,0,0,0,4,2.8,3.19,3.19,0,0,0,.86-.27"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M644.22,145.76c-.61-1.3-1.19-2.58-1.73-3.87a23.11,23.11,0,0,1,6.34-7.66c1.23,2.46,2.48,5,3.71,7.7s2.36,5.29,3.4,7.84a23.14,23.14,0,0,1-9.94-.19c-.6-1.26-1.2-2.52-1.78-3.82"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M649.24,143.46a48.45,48.45,0,0,1-3.42-9.73L670.7,122.3l8.53,18.61-24.91,11.44a49.82,49.82,0,0,1-5.08-8.89"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M649.24,143.46a48.45,48.45,0,0,1-3.42-9.73L670.7,122.3l8.53,18.61-24.91,11.44a49.82,49.82,0,0,1-5.08-8.89"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M664.09,123.48c1.12-.52,26.55-31.22,29.54-32.69s11.4,9.23,18.16,24,9.57,27.88,6.31,29.39-42.9.55-44,1.06-4.65-3.78-7.4-9.79-4-11.32-2.57-11.94"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M699.94,120.18c6.76,14.74,14.9,25.46,18.16,24s.46-14.57-6.31-29.39-14.89-25.46-18.16-24-.45,14.68,6.31,29.39"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M707.74,116.56c.46,1,.89,2,1.3,2.91a25,25,0,0,1-6.39,6.5c-.94-1.84-1.88-3.78-2.81-5.78s-1.76-4-2.56-5.9a25.08,25.08,0,0,1,9.09-.59,12.9,12.9,0,0,1,1.37,2.86"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M707.74,116.56c.46,1,.89,2,1.3,2.91a25,25,0,0,1-6.39,6.5c-.94-1.84-1.88-3.78-2.81-5.78s-1.76-4-2.56-5.9a25.08,25.08,0,0,1,9.09-.59,12.9,12.9,0,0,1,1.37,2.86"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 464.25,
    y: 35,
    width: 37.31,
    height: 59.89,
    transform: "translate(238.42 486.42) rotate(-67.54)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "462.35 36.26 482.9 64.94 517.7 59.14 462.35 36.26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 212.93,
    y: 36.84,
    width: 27.53,
    height: 27.53,
    rx: 5.01,
    transform: "translate(108.5 250.56) rotate(-72)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.85,47.62c0-.19,0-.39.05-.58a4.42,4.42,0,0,0-1.12-3.22,1.27,1.27,0,0,0-1.69-.2l-3,1.94a1.33,1.33,0,0,0-.4,1.84c.28.47.59.93.89,1.39l.12.16a12.27,12.27,0,0,1-6.93,4.45l-.65-1c-.11-.17-.22-.35-.34-.52a1.31,1.31,0,0,0-1.49-.57,2.17,2.17,0,0,0-.53.26L218,53.3a1.75,1.75,0,0,0-.67.73c0,.12-.05.24-.08.36a3.2,3.2,0,0,0,.16.71,4.72,4.72,0,0,0,1,1.38,3.88,3.88,0,0,0,1.74,1,7.67,7.67,0,0,0,1.35.17,10.64,10.64,0,0,0,3.41-.46,16.25,16.25,0,0,0,3.17-1.3,26.88,26.88,0,0,0,3.87-2.54,13.65,13.65,0,0,0,2.58-2.57,7.64,7.64,0,0,0,.9-1.6c.09-.24.17-.47.26-.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 721.09,
    cy: 234.8,
    r: 14.71
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 419.01,
    cy: 229.21,
    r: 10.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 36.48,
    cy: 50.51,
    r: 10.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailmarketingtab);
export default __webpack_public_path__ + "static/media/email marketing tab.a93e94e78121422f777fc5613118e7f6.svg";
export { ForwardRef as ReactComponent };